import { defineConfig } from 'cva';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        // ↓ Add values to existing theme scale or create a new one
        theme: {
            spacing: ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'],
        },
    },
});

export const { cva, cx, compose } = defineConfig({
    hooks: {
        onComplete: (className) => twMerge(className),
    },
});

export type MergeVariantProps<C, V> = Omit<C, keyof V> & V;

export { type VariantProps } from 'cva';
